module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "lettern"
  }, [_vm._v("Beverly Royal School System")]), _vm._v(" "), _c('p', {
    staticClass: "lettern"
  }, [_vm._v("18 Crown Jewel Road")]), _vm._v(" "), _c('p', {
    staticClass: "lettern"
  }, [_vm._v("Beverly Hills, California")]), _vm._v(" "), _c('p', {
    staticClass: "letter1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Dear Mr. and Mrs. Cummings:")])]), _vm._v(" "), _c('p', {
    staticClass: "letter1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("As you know, the school has been conducting IQ tests to better address the needs and placement of our students. We always suspected that we were going to get extraordinary results when Mayfair was tested, but no one fully understood or anticipated just how extraordinary these results would be.")])]), _vm._v(" "), _c('p', {
    staticClass: "letteri"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("To put it into perspective, this is a generally considered scale by which most educational institutions judge these results.")])]), _vm._v(" "), _c('p', {
    staticClass: "letteri"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("IQ scores of 115 to 129 indicate a bright student who should do well with his or her educational pursuits.")])]), _vm._v(" "), _c('p', {
    staticClass: "letteri"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("We consider those with scores of 130 to 144 moderately gifted and those with 145 to 159 highly gifted. Anyone with scores between 160 and 179 is recognized as exceptionally gifted.")])]), _vm._v(" "), _c('p', {
    staticClass: "letteri"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Rare are those whose scores reach 180. We consider such an individual profoundly gifted. To put it into even better perspective for you, statistically, these students are one in three million; so, for example, in the state of California, with a population of approximately 36 million, there are only eleven others who belong in this classification with Mayfair.")])]), _vm._v(" "), _c('p', {
    staticClass: "letteri"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Needless to say, we’re all very excited about this, and I would like to invite you in to discuss Mayfair’s future, what to anticipate, and what to do to ensure that her needs are fully addressed.")])]), _vm._v(" "), _c('p', {
    staticClass: "letterr1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sincerely yours,")])]), _vm._v(" "), _c('p', {
    staticClass: "letterr"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Gloria Fishman, Psychologist")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caced76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 69
// module chunks = 0